var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkPower())?_c('el-button',_vm._b({attrs:{"loading":_vm.loading},on:{"click":_vm.handleClick}},'el-button',_vm.omit(_vm.$attrs, 'onClick'),false),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }